module.exports = __webpack_public_path__ + "img/vertical_6_7_5010.f814f0aa.png";